export enum StatusFaceDetector {
    NOT_LOADED = "not-loaded",
    LOADING = "loading",
    LOADED = "loaded"
}
